import { useState, useEffect, useRef } from "react";

import { pollFn } from "helpers/commonHelpers";

type PollingFnArgs = {
  fn: Function;
  delay: number;
  maxPollCount: number;
  callFirstTimeImmediately: boolean;
  onComplete: Function;
};
/**
 * usePollingAction custom hook, will be used for polling of any function,
 */
export default function usePollingAction() {
  const [isPollingInProgress, setIsPollingInProgress] = useState(false);
  const pollingRef = useRef<any>(null);

  useEffect(
    () => () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    },
    [],
  );

  const startPolling = ({ fn, delay, maxPollCount, callFirstTimeImmediately, onComplete }: PollingFnArgs) => {
    setIsPollingInProgress(true);
    pollingRef.current = pollFn({
      fn,
      delay,
      maxPollCount,
      callFirstTimeImmediately,
      onComplete: () => {
        setIsPollingInProgress(false);
        if (onComplete) {
          onComplete();
        }
      },
    });
  };

  return { startPolling, isPollingInProgress };
}
